/**
 * Suchverlauf im leeren Suchfeld.
 *
 * Zeigt vor der ersten Eingabe zwei Listen an:
 *   1. zuletzt angesehene Produkte
 *   2. zuletzt gesuchte Begriffe
 *
 * Die angesehenen Produkte liegen bereits im Theme: app.js schreibt beim
 * Aufruf einer Produktseite den Handle nach localStorage['recently-viewed'].
 * Diese Liste wird hier nur gelesen, nicht ein zweites Mal gefuehrt.
 *
 * Die Suchbegriffe kommen aus dieser Datei. Erfasst wird auf der
 * Suchergebnisseite ueber den q-Parameter der Adresse. Damit landet jede
 * Suche im Verlauf, egal ob sie aus der Kopfzeile, aus einem Vorschlag oder
 * aus einem Lesezeichen kam.
 */
(function () {
  'use strict';

  var SCHLUESSEL_SUCHEN = 'so-letzte-suchen';
  var SCHLUESSEL_PRODUKTE = 'recently-viewed';
  var MAX_SUCHEN = 4;
  var MAX_PRODUKTE = 3;

  /** localStorage ist im privaten Modus mancher Browser gesperrt. */
  function lies(schluessel) {
    try {
      var roh = window.localStorage.getItem(schluessel);
      if (!roh || roh === 'undefined') return [];
      var wert = JSON.parse(roh);
      return Array.isArray(wert) ? wert : [];
    } catch (e) {
      return [];
    }
  }

  function schreibe(schluessel, wert) {
    try {
      window.localStorage.setItem(schluessel, JSON.stringify(wert));
    } catch (e) {}
  }

  function begriffe() {
    return lies(SCHLUESSEL_SUCHEN).filter(function (b) {
      return typeof b === 'string' && b.trim().length;
    }).slice(0, MAX_SUCHEN);
  }

  function produktHandles() {
    return lies(SCHLUESSEL_PRODUKTE).filter(function (h) {
      return typeof h === 'string' && h.length;
    }).slice(0, MAX_PRODUKTE);
  }

  function merkeSuche(begriff) {
    var sauber = (begriff || '').trim();
    if (!sauber || sauber.length > 80) return;
    // Die eigenen Abfragen der Verlaufsliste sollen nicht im Verlauf landen.
    if (sauber.indexOf('handle:') === 0) return;
    var klein = sauber.toLowerCase();
    var liste = lies(SCHLUESSEL_SUCHEN).filter(function (b) {
      return typeof b === 'string' && b.toLowerCase() !== klein;
    });
    liste.unshift(sauber);
    schreibe(SCHLUESSEL_SUCHEN, liste.slice(0, 10));
  }

  function loesche() {
    try {
      window.localStorage.removeItem(SCHLUESSEL_SUCHEN);
      window.localStorage.removeItem(SCHLUESSEL_PRODUKTE);
    } catch (e) {}
    window.recentlyViewedIds = [];
    produktSpeicher = { schluessel: '', markup: '' };
  }

  function hatEintraege() {
    return begriffe().length > 0 || produktHandles().length > 0;
  }

  function maskiere(text) {
    var d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML;
  }

  function suchUrl(begriff) {
    var basis = (window.theme && theme.routes && theme.routes.search_url) || '/search';
    return basis + '?q=' + encodeURIComponent(begriff);
  }

  /**
   * Holt die Karten der angesehenen Produkte. Die Suche liefert sie nach
   * Relevanz, gebraucht wird aber die Reihenfolge des Verlaufs, deshalb wird
   * anhand des Handles neu sortiert.
   */
  function holeProdukte(handles) {
    if (!handles.length) return Promise.resolve('');
    var basis = (window.theme && theme.routes && theme.routes.search_url) || '/search';
    var abfrage = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var url = basis + '?view=such-verlauf&type=product&q=' + encodeURIComponent(abfrage);

    return fetch(url)
      .then(function (a) { return a.ok ? a.text() : ''; })
      .then(function (text) {
        if (!text.trim()) return '';
        var huelle = document.createElement('div');
        huelle.innerHTML = text;
        var karten = Array.prototype.slice.call(huelle.querySelectorAll('product-card-small'));
        if (!karten.length) return '';
        karten.sort(function (a, b) {
          return handles.indexOf(a.dataset.productHandle) - handles.indexOf(b.dataset.productHandle);
        });
        return karten.map(function (k) { return k.outerHTML; }).join('');
      })
      .catch(function () { return ''; });
  }

  var produktSpeicher = { schluessel: '', markup: '' };

  /**
   * Baut die Innereien des Ergebnis-Popups. Aufbau und Klassen entsprechen
   * dem Abschnitt predictive-search, damit dieselben Stilregeln greifen.
   *
   * Der Rahmen entsteht ohne Warten, damit das Popup sofort aufgeht, wenn
   * jemand in die Suche klickt. Die Produktkarten muessen erst geholt werden
   * und werden nachgereicht; beim zweiten Oeffnen liegen sie im Speicher und
   * stehen ebenfalls sofort da.
   */
  function rahmen() {
    var liste = begriffe();
    var handles = produktHandles();
    if (!liste.length && !handles.length) return '';

    var teile = '';
    if (handles.length) {
      var vorrat = produktSpeicher.schluessel === handles.join(',') ? produktSpeicher.markup : '';
      teile +=
        '<div class="thb-ps__panel thb-ps__panel--produkte thb-verlauf__produkte side-panel-content--tab-panel tab-active">' +
        '<div class="thb-ps__heading">Zuletzt angesehen</div>' +
        '<div class="thb-verlauf__karten">' + vorrat + '</div></div>';
    }
    if (liste.length) {
      teile +=
        '<div class="thb-ps__panel thb-ps__panel--begriffe thb-verlauf__begriffe side-panel-content--tab-panel' +
        (handles.length ? '' : ' tab-active') + '">' +
        '<div class="thb-ps__heading">Letzte Suchanfragen</div>' +
        '<div class="thb-predictive-search--popular"><ul>' +
        liste.map(function (b) {
          return '<li><a href="' + maskiere(suchUrl(b)) + '" class="predictive-search__item link link--text">' +
            maskiere(b) + '</a></li>';
        }).join('') +
        '</ul></div></div>';
    }

    return '<scroll-shadow><div class="side-panel-content--inner thb-verlauf">' + teile +
      '<button type="button" class="thb-verlauf__loeschen">Verlauf löschen</button>' +
      '</div></scroll-shadow>';
  }

  /**
   * Traegt die Produktkarten in einen bereits eingebauten Rahmen nach.
   * Findet die Suche keine der Handles mehr, verschwindet der Abschnitt
   * samt Ueberschrift, statt leer stehen zu bleiben.
   */
  function fuelleProdukte(wurzel) {
    var abschnitt = wurzel && wurzel.querySelector('.thb-verlauf__produkte');
    if (!abschnitt) return Promise.resolve();
    var ziel = abschnitt.querySelector('.thb-verlauf__karten');
    var handles = produktHandles();
    var schluessel = handles.join(',');

    if (produktSpeicher.schluessel === schluessel) {
      if (!produktSpeicher.markup) abschnitt.remove();
      return Promise.resolve();
    }

    return holeProdukte(handles).then(function (markup) {
      produktSpeicher = { schluessel: schluessel, markup: markup };
      if (!markup) {
        abschnitt.remove();
        return;
      }
      if (ziel && !ziel.innerHTML.trim()) ziel.innerHTML = markup;
    });
  }

  // Jede aufgerufene Suchergebnisseite landet im Verlauf.
  try {
    if (/(^|\/)search/.test(window.location.pathname)) {
      var q = new URLSearchParams(window.location.search).get('q');
      if (q) merkeSuche(q);
    }
  } catch (e) {}

  window.SoSuchVerlauf = {
    hatEintraege: hatEintraege,
    rahmen: rahmen,
    fuelleProdukte: fuelleProdukte,
    merkeSuche: merkeSuche,
    loesche: loesche
  };
})();
